// extracted by mini-css-extract-plugin
module.exports = {"card":"VideoCard_card_2ZJE6","mobile":"VideoCard_mobile_1-PYv","heading":"VideoCard_heading_3LzGi"};